// extracted by mini-css-extract-plugin
module.exports = {"link__wrapper":"style_link__wrapper__1S5-7","link__container":"style_link__container__LeL3d","link__svg":"style_link__svg__3O7jh","link__content":"style_link__content__mW8GN"};